var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.049,
    height: 18.049,
    viewBox: "0 0 18.049 18.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-icn",
    transform: "translate(-1159 -604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "download_1_",
    "data-name": "download (1)",
    d: "M18.049,16.921a1.128,1.128,0,0,1-1.128,1.128H1.128a1.128,1.128,0,1,1,0-2.256H16.921A1.128,1.128,0,0,1,18.049,16.921ZM8.227,13.347a1.128,1.128,0,0,0,1.6,0l4-4a1.128,1.128,0,1,0-1.6-1.6L10.153,9.826v-8.7a1.128,1.128,0,0,0-2.256,0v8.7L5.825,7.755a1.128,1.128,0,1,0-1.6,1.6Z",
    transform: "translate(1159 604)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcn);
export default __webpack_public_path__ + "static/media/download-icn.f3713ceaf517cf37e7f54e7ace6c06c4.svg";
export { ForwardRef as ReactComponent };